<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table responsive"
               matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Name:</span>
          <span>
            <a *ngIf="hasEditAccess && !showSelection" [routerLink]="[detailsUrl, 'edit', row.id]">
              {{ row.name }}
            </a>
            <span *ngIf="!hasEditAccess || showSelection">{{ row.name }}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="phoneNumber">
        <mat-header-cell *matHeaderCellDef>Phone Number</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Phone Number:</span>
          {{ row.phoneNumber | phoneNumber }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="language">
        <mat-header-cell *matHeaderCellDef mat-sort-header="language">Language</mat-header-cell>
        <mat-cell *matCellDef="let row" style="flex-wrap: wrap;">
          <span class="mobile-label">Language:</span>
          <span style="padding-right: 10px"><b>{{ row.language | language }}</b></span>
          <span>{{ previewTemplateBody(row.components) }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Status:</span>
          {{ row.status | whatsAppStatus }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header="category">Category</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Category:</span>
          {{ row.category | whatsAppCategory }}
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"
               (click)="onRowClicked(row)"
               class="call-logs-row"
               [ngClass]="{'show-selection': showSelection}"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
